import React from "react";
import Header from "src/components/common/Header";
import Sidebar from "src/components/common/Sidebar";
import Footer from "src/components/common/Footer";
import { RODEO_PAGE_NAME } from "src/_config/site_statics";
import PaymentSuccess from "src/components/settings/subscriptions/PaymentSuccess";

const PaymentSuccessContainer: React.FC = () => {
  return (
    <>
      <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.SETTINGS_SUBSCRIPTIONS} />
      <PaymentSuccess />
      <Footer variant="dashboard" />
    </>
  );
};

export default PaymentSuccessContainer;
